<div class="market-performance-box" [ngClass]="type">
  <div class="market-performance-box-title">
    <p class="ds-ui-2"><ng-content></ng-content></p>
    <ion-icon name="info2" (click)="openExtraInfo()"></ion-icon>
  </div>
  <div class="market-performance-box-extra-info" *ngIf="showInfo">
    <p class="ds-ui-3" [innerHTML]="info | translate"></p>
  </div>
  <div class="market-performance-box-detail">
    <div>
      <span class="ds-ui-2" *ngIf="!note">{{ 'PERFORMANCE.contentSwitcher.performance.last30Days.netLabel' | translate}}</span>
      <app-ds-returns [value]="net / 100"></app-ds-returns>
    </div>
    <div *ngIf="gross">
      <span class="ds-ui-2">{{ 'PERFORMANCE.contentSwitcher.performance.last30Days.grossLabel' | translate}}</span>
      <app-ds-returns [value]="gross / 100"></app-ds-returns>
    </div>
    <div *ngIf="note">
      <span class="ds-ui-3 note">{{ note | translate: { date: benchmarkDate } }}</span>
    </div>
  </div>
</div>
